export class ContractorIdReq{
    contractorId : number
    constructor(contractorId:number){
        this.contractorId = contractorId
    }
}